export default __webpack_public_path__ + "static/media/3.a5586075.jpg";